export default __webpack_public_path__ + "static/media/audio-wave.1137524e.gif";